import React, { useState, useRef, useEffect } from "react";
import { IconChevronDown, IconPlus, IconSettings } from "@tabler/icons-react";
import { useCRM } from "../CRMContext";

const formatCurrency = (value) => {
  if (!value) return "R$ 0";
  return new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL", maximumFractionDigits: 0 }).format(value);
};

const PipelineSelector = ({ onManage }) => {
  const { state, switchPipeline } = useCRM();
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const activePipeline = state.pipelines.find((p) => p.id === state.activePipelineId);

  useEffect(() => {
    const handleClick = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, []);

  const handleSelect = (id) => {
    switchPipeline(id);
    setOpen(false);
  };

  return (
    <div className="crm-pipeline-selector" ref={ref}>
      <button className="crm-pipeline-selector__trigger" onClick={() => setOpen(!open)}>
        <span>{activePipeline?.name || "Pipeline"}</span>
        {activePipeline?.is_owner === false && activePipeline?.created_by_name && (
          <span className="crm-pipeline-selector__owner-badge">
            {activePipeline.created_by_name.split(" ")[0]}
          </span>
        )}
        <IconChevronDown size={16} />
      </button>

      {open && (
        <div className="crm-pipeline-selector__dropdown">
          {state.pipelines.map((p) => (
            <div
              key={p.id}
              className={`crm-pipeline-selector__item ${p.id === state.activePipelineId ? "crm-pipeline-selector__item--active" : ""}`}
              onClick={() => handleSelect(p.id)}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <span>{p.name}</span>
                {p.is_owner === false && p.created_by_name && (
                  <span className="crm-pipeline-selector__owner-badge">
                    {p.created_by_name.split(" ")[0]}
                  </span>
                )}
              </div>
              <span className="crm-pipeline-selector__meta">
                {p.contacts_count || 0} contatos &middot; {formatCurrency(p.total_value)}
              </span>
            </div>
          ))}
          {onManage && (
            <div className="crm-pipeline-selector__action" onClick={() => { setOpen(false); onManage(); }}>
              <IconSettings size={16} />
              <span>Gerenciar Pipelines</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default PipelineSelector;
